import { render, staticRenderFns } from "./InfoGraphicsDetailTable.vue?vue&type=template&id=6909bc7f"
import script from "./InfoGraphicsDetailTable.vue?vue&type=script&lang=js"
export * from "./InfoGraphicsDetailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports